export const isInIframe = (): boolean => {
  if (typeof window === 'undefined') return false;

  try {
    return Boolean(window.parent) && window.parent !== window;
  } catch {
    return false;
  }
};

type WindowWithReactNativeWebView = Window & {
  ReactNativeWebView?: { postMessage: (message: string) => void };
};

/**
 * Sends a message to the React Native WebView bridge (when running inside the app).
 * No-op when not in a WebView or when window is undefined (SSR).
 */
export const postMessageToApp = (message: Record<string, unknown>): boolean => {
  if (typeof window === 'undefined') return false;
  const win = window as WindowWithReactNativeWebView;
  if (!win.ReactNativeWebView) return false;
  try {
    win.ReactNativeWebView.postMessage(JSON.stringify(message));
    return true;
  } catch {
    return false;
  }
};

export const postMessageToWeb = (
  message: unknown,
  targetOrigin: string = '*'
): boolean => {
  if (typeof window === 'undefined') return false;
  if (!isInIframe()) return false;
  if (!window.parent) return false;

  try {
    window.parent.postMessage(message, targetOrigin);
    return true;
  } catch {
    return false;
  }
};

export const revealApp = () => {
  if (typeof document === 'undefined') return;
  document.querySelector('.App')?.classList.add('__ready');
  document.getElementById('__initial-loader')?.remove();
};

export const getUrlSearchParam = (key: string): string | null => {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get(key);
};

export const getUrlLocale = (): string | null => {
  if (typeof window === 'undefined') return null;
  const match = window.location.pathname.match(/^\/([^/]+)/);
  if (match && (match[1] === 'th' || match[1] === 'en')) {
    return match[1];
  }
  return null;
};
